import React from "react";
import { Toolbar as GoldToolbar } from "gold-ui-kit";

export const ToolbarButton = ({ icon, label, onClick, testId, disabled, className, active, color }) => (
  <GoldToolbar.Button
    icon={icon ? <span className="text-sm leading-none">{icon}</span> : undefined}
    onClick={onClick}
    disabled={disabled}
    active={active}
    color={color}
    className={className}
    data-testid={testId}
  >
    {label}
  </GoldToolbar.Button>
);

export const ToolbarSeparator = () => <GoldToolbar.Divider />;

// Pages put inputs and dropdowns in here, so it wraps instead of scrolling (a scroll box would clip their popups).
const Toolbar = ({ children }) => (
  <GoldToolbar
    variant="outline"
    radius="md"
    className="!w-full !flex-wrap !overflow-visible !rounded-none !border-x-0 !border-t-0 bg-slate-50/80 px-3 py-2 text-xs"
  >
    {children}
  </GoldToolbar>
);

export default Toolbar;
